import {Question} from '../shared/question';
import {Response} from '../shared/response';

export class Ploom{

    question1:Question;
    question2:Question;
    question3:Question;
    question4:Question;
    question5:Question;
    question6:Question;
    question7:Question;
    question8:Question;
    question9:Question;
    question10:Question;
    question11:Question;
    question12:Question;
    question13:Question;
    question14:Question;
    question15:Question;
    question16:Question;
    question17:Question;

    questions: Array<Question>;

    constructor(){
        
        this.question1 = new Question(1, [], 
            'In calitate de fumator adult existent, cât de des folosiți tigari in pachet?',
            '',
            'radio',
            [new Response(1, 'Zilnic'), 
            new Response(2, 'Săptămânal (cel puțin o dată pe săptămână)'), 
            new Response(3, 'Lunar (cel puțin o dată în ultimele 4 săptămâni)'), 
            new Response(4, 'Am încercat/folosit cel puțin o data, dupa 18 ani, dar nu am continuat'),
            new Response(5, 'Am încercat/folosit cel puțin o data, dupa 18 ani, dar nu am continuat'),
            new Response(6, 'Nu am folosit niciodată acest produs')
            ],
            false
        );

        this.question2 = new Question(2, [], 
            'In calitate de fumator adult existent, cât de des folosiți dispozitiv electronic care încălzeste tutunul? ',
            '',
            'radio',
            [new Response(1, 'Zilnic'), 
            new Response(2, 'Săptămânal (cel puțin o dată pe săptămână)'), 
            new Response(3, 'Lunar (cel puțin o dată în ultimele 4 săptămâni)'), 
            new Response(4, 'Am încercat/folosit cel puțin o data, dupa 18 ani, dar nu am continuat'),
            new Response(5, 'Am încercat/folosit cel puțin o data, dupa 18 ani, dar nu am continuat'),
            new Response(6, 'Nu am folosit niciodată acest produs')
            ],
            false
        );

        this.question3 = new Question(3, [], 
            'In calitate de fumator adult existent, cât de des folosiți tigari electronice (de unică folosință, sau cu rezervor, capsule)? ',
            '',
            'radio',
            [new Response(1, 'Zilnic'), 
            new Response(2, 'Săptămânal (cel puțin o dată pe săptămână)'), 
            new Response(3, 'Lunar (cel puțin o dată în ultimele 4 săptămâni)'), 
            new Response(4, 'Am încercat/folosit cel puțin o data, dupa 18 ani, dar nu am continuat'),
            new Response(5, 'Am încercat/folosit cel puțin o data, dupa 18 ani, dar nu am continuat'),
            new Response(6, 'Nu am folosit niciodată acest produs')
            ],
            false
        );

        this.question4 = new Question(4, [], 
            'In calitate de fumator adult existent, cât de des folosiți tutun rulat? ',
            '',
            'radio',
            [new Response(1, 'Zilnic'), 
            new Response(2, 'Săptămânal (cel puțin o dată pe săptămână)'), 
            new Response(3, 'Lunar (cel puțin o dată în ultimele 4 săptămâni)'), 
            new Response(4, 'Am încercat/folosit cel puțin o data, dupa 18 ani, dar nu am continuat'),
            new Response(5, 'Am încercat/folosit cel puțin o data, dupa 18 ani, dar nu am continuat'),
            new Response(6, 'Nu am folosit niciodată acest produs')
            ],
            false
        );
        
        this.question5 = new Question(5, [1],
            'Câte țigări in pachet fumați, în medie, pe zi?',
            '',
            'free-number-label',
            [new Response(1, '')],
            false
        );

        this.question5.render = ()=>{
            return this.question1.responses.filter(rsp=>rsp.id === 1)[0].selected;
        }

        this.question6 = new Question(6, [1],
            'Câte țigări in pachet fumați, în medie, pe săptămână?',
            '',
            'free-number-label',
            [new Response(1, '')],
            false
        );

        this.question6.render = ()=>{
            return this.question1.responses.filter(rsp=>rsp.id === 2)[0].selected || this.question1.responses.filter(rsp=>rsp.id === 3)[0].selected;
        }

        this.question7 = new Question(7, [1],
            'Care este marca dvs. de țigări pe care o fumați cel mai des?',
            '',
            'dropdown',
            this.quoestion7Responses,
            false
        );

        this.question7.render = ()=>{
            return this.question1.responses.filter(rsp=>rsp.id === 1)[0].selected || 
                this.question1.responses.filter(rsp=>rsp.id === 2)[0].selected || this.question1.responses.filter(rsp=>rsp.id === 3)[0].selected;
        }

        this.question8 = new Question(8, [2], 
            'Pe care dintre următoarele mărci de dispozitive electronice care incălzesc tutunul le cunoasteți, indiferent dacă le-ați folosit sau nu?',
            'Bifati toate marcile de dispozitive de care ati auzit.',
            'checkbox',
            [new Response(1, 'glo'), 
            new Response(2, 'iQOS (inclusiv Iluma)'), 
            new Response(3, 'lil'), 
            new Response(4, 'Ploom')
            ],
            true
        );

        this.question8.render = ()=>{
            return this.question2.responses.filter(rsp=>rsp.id === 1)[0].selected || 
                this.question2.responses.filter(rsp=>rsp.id === 2)[0].selected || this.question2.responses.filter(rsp=>rsp.id === 3)[0].selected;
        }

        this.question9 = new Question(9, [8], 
            'Pe care le-ati incercat vreodată?',
            'Bifati toate marcile pe care le-ati incercat',
            'checkbox',
            [new Response(1, 'glo'), 
            new Response(2, 'iQOS (inclusiv Iluma)'), 
            new Response(3, 'lil'), 
            new Response(4, 'Ploom')
            ],
            true
        );

        let question9ResponseRenderer = (rsp:Response):boolean=>{
            let question8SelectedIds = this.question8.responses.filter(r => r.selected).map(r => r.id);
            return question8SelectedIds.indexOf(rsp.id) >= 0;
        }
        this.question9.responses[0].render=question9ResponseRenderer;
        this.question9.responses[1].render=question9ResponseRenderer;
        this.question9.responses[2].render=question9ResponseRenderer;
        this.question9.responses[3].render=question9ResponseRenderer;

        this.question9.render = ()=>{
            return this.question8.responses.filter(r => r.selected).length>0;
        }


        this.question10 = new Question(10, [9], 
            'Pe care le folositi in prezent cel putin o data pe lună?',
            'Bifati toate raspunsurile care se aplica',
            'checkbox',
            [new Response(1, 'glo'), 
            new Response(2, 'iQOS (inclusiv Iluma)'), 
            new Response(3, 'lil'), 
            new Response(4, 'Ploom')
            ],
            true
        );

        let question10ResponseRenderer = (rsp:Response):boolean=>{
            let question9SelectedIds = this.question9.responses.filter(r => r.selected).map(r => r.id);
            return question9SelectedIds.indexOf(rsp.id) >= 0;
        }
        this.question10.responses[0].render=question10ResponseRenderer;
        this.question10.responses[1].render=question10ResponseRenderer;
        this.question10.responses[2].render=question10ResponseRenderer;
        this.question10.responses[3].render=question10ResponseRenderer;

        this.question10.render = ()=>{
            return this.question9.responses.filter(r => r.selected).length>0;
        }

        this.question11 = new Question(11, [10], 
            'Pe care il folositi cel mai des?',
            'Bifati o singura marca ',
            'radio',
            [new Response(1, 'glo'), 
            new Response(2, 'iQOS (inclusiv Iluma)'), 
            new Response(3, 'lil'), 
            new Response(4, 'Ploom')
            ],
            true
        );

        let question11ResponseRenderer = (rsp:Response):boolean=>{
            let question10SelectedIds = this.question10.responses.filter(r => r.selected).map(r => r.id);
            return question10SelectedIds.indexOf(rsp.id) >= 0;
        }
        this.question11.responses[0].render=question11ResponseRenderer;
        this.question11.responses[1].render=question11ResponseRenderer;
        this.question11.responses[2].render=question11ResponseRenderer;
        this.question11.responses[3].render=question11ResponseRenderer;

        this.question11.render = ()=>{
            return this.question10.responses.filter(r => r.selected).length>0;
        }

        this.question12 = new Question(12, [2, 10], 
            'Câte tigari special facute pentru dispozitivele electronice care incalzesc tutunul utilizati, în medie, pe zi?',
            '',
            'free-number-label',
            [new Response(1, 'glo'), 
            new Response(2, 'iQOS (inclusiv Iluma)'), 
            new Response(3, 'lil'), 
            new Response(4, 'Ploom')],
            false
        );
        
        let question12ResponseRenderer = (rsp:Response):boolean=>{
            let question10SelectedIds = this.question10.responses.filter(r => r.selected).map(r => r.id);
            return question10SelectedIds.indexOf(rsp.id) >= 0;
        }
        this.question12.responses[0].render=question12ResponseRenderer;
        this.question12.responses[1].render=question12ResponseRenderer;
        this.question12.responses[2].render=question12ResponseRenderer;
        this.question12.responses[3].render=question12ResponseRenderer;

        this.question12.render = ()=>{
            let question10SelectedIds = this.question10.responses.filter(r => r.selected);
            return question10SelectedIds.length > 0 && this.question2.responses.filter(rsp=>rsp.id === 1)[0].selected;
        }

        
        
        
        this.question13 = new Question(13, [2, 10], 
            'Cate tigari special facute pentru dispozitivele electronice care incalzesc tutunul utilizati in medie pe saptamana?',
            '',
            'free',
            [new Response(1, 'glo'), 
            new Response(2, 'iQOS (inclusiv Iluma)'), 
            new Response(3, 'lil'), 
            new Response(4, 'Ploom')],
            false
        );
        
        let question13ResponseRenderer = (rsp:Response):boolean=>{
            let question10SelectedIds = this.question10.responses.filter(r => r.selected).map(r => r.id);
            return question10SelectedIds.indexOf(rsp.id) >= 0;
        }
        this.question13.responses[0].render=question13ResponseRenderer;
        this.question13.responses[1].render=question13ResponseRenderer;
        this.question13.responses[2].render=question13ResponseRenderer;
        this.question13.responses[3].render=question13ResponseRenderer;

        this.question13.render = ()=>{
            let question10SelectedIds = this.question10.responses.filter(r => r.selected);
            return question10SelectedIds.length > 0 && this.question2.responses.filter(rsp=>rsp.id === 2)[0].selected || this.question2.responses.filter(rsp=>rsp.id === 3)[0].selected;
        }
        
        
        this.question14 = new Question(14, [8], 
            'Ati auzit de marca de dispozitiv electronic care încălzeste tutunul Ploom?',
            '',
            'radio',
            [new Response(1, 'Da'), new Response(2, 'Nu')],
            false
        );
        
        this.question14.render = ()=>{
            let question8SelectedIds = this.question8.responses.filter(r => r.selected).map(r => r.id);
            return question8SelectedIds && question8SelectedIds.length > 0 && question8SelectedIds.filter(id=>id===4).length === 0;
        }
        
        this.question15 = new Question(15, [8, 14], 
            'Ai incercat dispozitivul Ploom? ',
            '',
            'radio',
            [new Response(1, 'Da'), new Response(2, 'Nu')],
            false
        );
        
        this.question15.render = ()=>{
            // let question8SelectedPloom = this.question8.responses.filter(r => r.selected).map(r => r.id).filter(id=>id===4).length === 1;
            let question9SelectedPloom = this.question9.responses.filter(r => r.selected).map(r => r.id).filter(id=>id===4).length === 1;
            let question10SelectedPloom = this.question10.responses.filter(r => r.selected).map(r => r.id).filter(id=>id===4).length === 1;
            let question11SelectedPloom = this.question11.responses.filter(r => r.selected).map(r => r.id).filter(id=>id===4).length === 1;
            let selectedPloom = question11SelectedPloom || question9SelectedPloom || question10SelectedPloom
            let question14SelectedYes = this.question14.responses.filter(rsp=>rsp.id === 1)[0].selected;
            if(!question14SelectedYes){
                return false;
            }
            return question14SelectedYes || !(selectedPloom);
        }
        
        this.question16 = new Question(16, [8], 
            'Ati auzit de Sobranie sticks pentru Ploom?',
            '',
            'radio',
            [new Response(1, 'Da'), new Response(2, 'Nu')],
            false
        );
        
        this.question16.render = ()=>{

            // let question8SelectedPloom = this.question8.responses.filter(r => r.selected).map(r => r.id).filter(id=>id===4).length === 1;
            let question9SelectedPloom = this.question9.responses.filter(r => r.selected).map(r => r.id).filter(id=>id===4).length === 1;
            let question10SelectedPloom = this.question10.responses.filter(r => r.selected).map(r => r.id).filter(id=>id===4).length === 1;
            let question11SelectedPloom = this.question11.responses.filter(r => r.selected).map(r => r.id).filter(id=>id===4).length === 1;
            let selectedPloom = question11SelectedPloom || question9SelectedPloom || question10SelectedPloom
            // let question14SelectedYes = this.question14.responses.filter(rsp=>rsp.id === 1)[0].selected;
            return  !(selectedPloom);
        }
        
        
        
        
        this.question17 = new Question(17, [9, 10, 11, 14, 15], 
            'Cat de multumit/a ati fost de experienta de utilizare cu dispozitivul Ploom?',
            'Bifati un singur raspuns',
            'radio',
            [new Response(1, 'Extrem de multumit/a'), 
            new Response(2, 'Multumit/a'),
            new Response(3, 'Neutru'), 
            new Response(4, 'Nemultumit/a'),
            new Response(5, 'Foarte nemultumit/a')
        ],
            false
        );
        
        this.question17.render = ()=>{
            let question14SelectedIds = this.question14.responses.filter(r => r.selected).map(r => r.id);
            if(question14SelectedIds && question14SelectedIds[0] === 2){
                return false;
            }
            // let question15SelectedIds = this.question15.responses.filter(r => r.selected).map(r => r.id);
            // if(question15SelectedIds && question15SelectedIds[0] === 1){
            //     return true;
            // }
            let question9SelectedIds = this.question9.responses.filter(r => r.selected).map(r => r.id);
            let question10SelectedIds = this.question10.responses.filter(r => r.selected).map(r => r.id);
            let question11SelectedIds = this.question10.responses.filter(r => r.selected).map(r => r.id);
            return (question9SelectedIds && question9SelectedIds.length > 0 && question9SelectedIds.filter(id=>id===4).length === 1) || 
                (question10SelectedIds && question10SelectedIds.length > 0 && question10SelectedIds.filter(id=>id===4).length === 1) || 
                (question11SelectedIds && question11SelectedIds.length > 0 && question11SelectedIds.filter(id=>id===4).length === 1);
        }

        this.questions = [this.question1, this.question2, this.question3, this.question4, this.question5, this.question6, this.question7, this.question8,
            this.question9, this.question10, this.question11, this.question12, this.question13, this.question14, this.question15, this.question16, this.question17];
    }
    
    getQuestions():Array<Question>{
        return this.questions;
    }

    quoestion7Responses = [new Response(1, "Camel Filters (galben, scurte)"),
    new Response(2, "Camel Filters (galben, lungi)"),
    new Response(3, "Camel Compact negru (lungi)"),
    new Response(4, "Camel Compact albastru (lungi)"),
    new Response(5, "Camel Caster"),
    new Response(6, "Camel 1913 Original Filters (galben, cu camila neagra, lungi)"),
    new Response(7, "Camel 1913 Original Blue (albastru deschis, cu camila neagra, lungi)"),
    new Response(8, "Camel 1913 Original Black (negru, cu camila galbena, lungi)"),
    new Response(9, "Chesterfield negru (lungi)"),
    new Response(10, "Chesterfield albastru (lungi)"),
    new Response(11, "Chesterfield gri (lungi)"),
    new Response(12, "Chesterfield Tuned Silver"),
    new Response(13, "Chesterfield Tuned Blue"),
    new Response(14, "Davidoff Classic (rosu, lungi)"),
    new Response(15, "Davidoff Gold normale (auriu, lungi)"),
    new Response(16, "Davidoff Gold subtiri (auriu, lungi)"),
    new Response(17, "Davidoff Magenta subtiri (mov, lungi)"),
    new Response(18, "Davidoff Lilac subtiri (negru cu mici forme geometrice in colturi, lungi)"),
    new Response(19, "Davidoff Rose subtiri (roz, lungi)"),
    new Response(20, "Davidoff Silver normale (argintiu, lungi)"),
    new Response(21, "Davidoff Silver subtiri (argintiu, lungi)"),
    new Response(22, "Davidoff subtiri (caramiziu, lungi)"),
    new Response(23, "Davidoff White subtiri (alb, lungi)"),
    new Response(24, "Davidoff District Negru (normale, lungi)"),
    new Response(25, "Davidoff District Gold (auriu, slims, lungi)"),
    new Response(26, "Davidoff Teal (negru cu mici forme geometrice in colturi)"),
    new Response(27, "Dunhill pachet negru cu albastru inchis"),
    new Response(28, "Dunhill pachet alb"),
    new Response(29, "Dunhill pachet negru cu mix de culori (pastelate)"),
    new Response(30, "Dunhill Evoque verde (subtiri, lungi)"),
    new Response(31, "Dunhill Evoque roz (subtiri, lungi)"),
    new Response(32, "Dunhill Evoque bej (subtiri, lungi)"),
    new Response(33, "Dunhill Opus Enigma Black (pachet negru, subtiri/slims)"),
    new Response(34, "Dunhill Opus Enigma Blue (pachet cu nuante de albastru, subtiri/slims)"),
    new Response(35, "Dunhill albastru (lungi)"),
    new Response(36, "Dunhill gri (lungi)"),
    new Response(37, "Dunhill negru (lungi)"),
    new Response(38, "Dunhill alb (lungi)"),
    new Response(39, "Dunhill pachet negru cu puncte rosii (tigarete lungi)"),
    new Response(40, "DUNHILL SIGNATURE NO.11 (alb)"),
    new Response(41, "DUNHILL SIGNATURE NO.4 (olive/verde inchis)"),
    new Response(42, "DUNHILL SIGNATURE NO.6 (mov)"),
    new Response(43, "DUNHILL SIGNATURE NO.8 (black)"),
    new Response(44, "Kent Core Black/10 (negru, lungi)"),
    new Response(45, "Kent Core Blue/8 ( scurte)"),
    new Response(46, "Kent Core Blue/8 (lungi)"),
    new Response(47, "Kent Core Silver/4 ( scurte)"),
    new Response(48, "Kent Core Silver/4 (lungi)"),
    new Response(49, "Kent Core White/1 (lungi)"),
    new Response(50, "Kent Mode Blue"),
    new Response(51, "Kent Mode Silver (pachet cu gri)"),
    new Response(52, "Kent Nano Silver (negru cu argintiu, subtiri, scurte)"),
    new Response(53, "Kent Nano White (negru cu alb, subtiri, scurte)"),
    new Response(54, "Kent lungi, fostul pachet necartonat"),
    new Response(55, "Lucky Strike alb cu bulina rosie ( scurte)"),
    new Response(56, "Marlboro Gold scurte"),
    new Response(57, "Marlboro Gold lungi"),
    new Response(58, "Marlboro rosu lungi"),
    new Response(59, "Marlboro rosu scurte"),
    new Response(60, "Marlboro Filter Plus (lungi)"),
    new Response(61, "Marlboro Filter Plus ( scurte)"),
    new Response(62, "Marlboro Touch XL albastru inchis/7 (lungi)"),
    new Response(63, "Marlboro Fine Touch albastru deschis/4 ( scurte)"),
    new Response(64, "Marlboro Touch albastru inchis/6 ( scurte)"),
    new Response(65, "Marlboro Fine Touch XL albastru deschis/4 (lungi)"),
    new Response(66, "Marlboro XL Touch clear (pachet albastru deschis, lungi)"),
    new Response(67, "Marlboro Touch Plus XL (pachet albastru deschis, lungi)"),
    new Response(68, "Marlboro Red Touch XL (pachet negru)"),
    new Response(69, "Marlboro Gold Touch XL (pachet cu auriu)"),
    new Response(70, "Marlboro Micro Touch Emerald (subtiri, pachet verde)"),
    new Response(71, "Marlboro Micro Fine Touch albastru deschis (subtiri)"),
    new Response(72, "Marlboro Micro Touch albastru inchis (subtiri)"),
    new Response(73, "Pall Mall albastru ( scurte)"),
    new Response(74, "Pall Mall Extra cut gri inchis (lungi)"),
    new Response(75, "Pall Mall Extra cut gri deschis (lungi)"),
    new Response(76, "Pall Mall Extra cut negru (lungi)"),
    new Response(77, "Pall Mall S-Line Flow pachetul gri cu albastru, sau pachetul mov deschis"),
    new Response(78, "Pall Mall S-Line Flow pachetul gri cu roz, sau pachetul roz deschis"),
    new Response(79, "Pall Mall S-Line Flow ivoire"),
    new Response(80, "Pall Mall S-Line Flow turcoaz"),
    new Response(81, "Pall Mall Balance Flow negru"),
    new Response(82, "Pall Mall Balance Flow albastru"),
    new Response(83, "PALL MALL ASCEND"),
    new Response(84, "Pall Mall Ascend Black"),
    new Response(85, "Pall Mall Ascend Rose Gold"),
    new Response(86, "Parliament Aqua blue lungi"),
    new Response(87, "Parliament Aqua blue ( scurte)"),
    new Response(88, "Parliament Reserve Premium (subtiri, lungi)"),
    new Response(89, "Parliament Manhattan NYC Night (albastru inchis)"),
    new Response(90, "Parliament Manhattan NYC Aqua (albastru deschis)"),
    new Response(91, "Rothmans - alb cu albastru"),
    new Response(92, "Rothmans Classic Blue"),
    new Response(93, "Rothmans Classic Black"),
    new Response(94, "Rothmans Classic Red"),
    new Response(95, "Rothmans Classic Azure"),
    new Response(96, "Sobranie Black (negru, scurte)"),
    new Response(97, "Sobranie Black (negru, lungi)"),
    new Response(98, "Sobranie Blue (albastru, lungi)"),
    new Response(99, "Sobranie Chrome (gri, lungi)"),
    new Response(100, "Sobranie White (alb, lungi)"),
    new Response(101, "Sobranie Redefined Rosu (pachet negru cu rosu)"),
    new Response(102, "Sobranie subtiri negru"),
    new Response(103, "Sobranie subtiri roz"),
    new Response(104, "Sobranie subtiri alb"),
    new Response(105, "Sobranie subtiri Cocktail"),
    new Response(106, "Sobranie subtiri Christmas"),
    new Response(107, "Sobranie Collection negru (subtiri, lungi, pachet lat)"),
    new Response(108, "Sobranie Collection colorat (subtiri, lungi, pachet lat)"),
    new Response(109, "Sobranie Collection alb (subtiri, lungi, pachet lat)"),
    new Response(110, "Sobranie Collection Red"),
    new Response(111, "Sobranie Collection Lumia"),
    new Response(112, "Sobranie Collection albastru (subtiri, lungi, pachet lat)"),
    new Response(113, "Vogue La cigarette Bleue (subtiri, lungi)"),
    new Response(114, "Vogue La cigarette Ivoire (subtiri, lungi)"),
    new Response(115, "Vogue La cigarette Lilas (subtiri, lungi)"),
    new Response(116, "Vogue La cigarette Bleue Unique (subtiri, lungi)"),
    new Response(117, "Vogue La cigarette Rose Unique (subtiri, lungi)"),
    new Response(118, "Winston blue lungi (alb cu albastru)"),
    new Response(119, "Winston blue scurte (alb cu albastru)"),
    new Response(120, "Winston Classic rosu (lungi)"),
    new Response(121, "Winston Classic rosu ( scurte)"),
    new Response(122, "Winston Silver (gri cu alb, scurte)"),
    new Response(123, "Winston subtiri blue (albastru)"),
    new Response(124, "Winston subtiri silver (gri)"),
    new Response(125, "Winston Caster Super Line (subtiri, lungi)"),
    new Response(126, "Winston Nova (albastru complet)"),
    new Response(127, "Winston Nova Gold "),
    new Response(128, "Winston Plus Red (negru cu dungi rosii, lungi)"),
    new Response(129, "Winston XSpression (lungi, pachet albastru inchis)"),
    new Response(130, "Winston XSpression subtiri, lungi"),
    new Response(131, "Winston Caster (alb cu aramiu, lungi)"),
    new Response(132, "Winston Selection Night (maro inchis, lungi)"),
    new Response(133, "Winston Selection Sunrise (verde inchis, lungi)"),
    new Response(134, "Winston Selection Sunset (portocaliu inchis, lungi)"),
    new Response(135, "Winston Selection Skylite (albastru cu o parte portocalie, lungi)")]
    
}

